<template>
  <div>
    <Profile :selectedPageTemplate="selectedPageTemplate"/>
  </div>
</template>

<script>
  export default {
    components: {
      Profile: () => import('@/components/Design/View/ViewTheme'),
    },
    data: () => ({
      selectedPageTemplate: 'Profile',
    }),
    created () {
    }
  }
</script>
